import React, { useContext, useState } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';

const TrialBadge = () => {
  const { trialStatus, trialLoading } = useContext(GlobalContext);
  const [showDialog, setShowDialog] = useState(false);

  // Don't show badge if loading, no trial, or trial is expired
  if (trialLoading || !trialStatus || !trialStatus.has_trial || trialStatus.is_expired) {
    return null;
  }

  const { days_remaining } = trialStatus;

  const getBadgeColor = () => {
    if (days_remaining <= 3) {
      return 'bg-red-100 text-red-800 border-red-200';
    } else if (days_remaining <= 7) {
      return 'bg-orange-100 text-orange-800 border-orange-200';
    } else {
      return 'bg-blue-100 text-blue-800 border-blue-200';
    }
  };

  const handleBadgeClick = () => {
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  return (
    <>
      {/* Trial Badge */}
      <button
        onClick={handleBadgeClick}
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border transition-colors hover:opacity-80 ${getBadgeColor()}`}
      >
        Free Trial: {days_remaining} day{days_remaining !== 1 ? 's' : ''} left
      </button>

      {/* Dialog Modal */}
      {showDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
            <div className="space-y-4 text-gray-700">
              <p>
                To extend your trial, email{' '}
                <a
                  href="mailto:support@internhubapp.com"
                  className="text-blue-600 hover:text-blue-800 font-medium"
                >
                  support@internhubapp.com
                </a>
                !
              </p>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={handleCloseDialog}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TrialBadge;
